<template>
	<div class="navbox">
		<div class="logo">
			<img class="kunlun_logo" @click="toPage({name:'home'})" src="../../images/xianlai_logo.png" />
		</div>
		<div class="list">
					<router-link to="/home">首页</router-link>
					<!-- TODO: <router-link to="/charge">充值中心</router-link> -->
					<!-- <router-link to="/aboutus">关于我们</router-link> -->
					<!--<router-link to="/guardianship">服务协议</router-link>
					<router-link to="/addicted">隐私保护</router-link>
					<router-link to="/dispute">纠纷处理</router-link>
				  <router-link to="/parentcustody">家长监护</router-link>
					<router-link to="/lostinself">防沉迷</router-link>-->
		</div>
		<div class="action" v-if="!haslogin">
			<router-link to="/reg">注册</router-link>
			<router-link to="/home">登录</router-link>
		</div>
		<div class="action" v-else>
			<span>欢迎你，{{userData.gid}}</span><span class="logout" @click="toLogout">退出登录</span>
		</div>
	</div>
</template>

<script>
  import { mapMutations } from 'vuex'
  import { mapState } from 'vuex'
  export default {
		data() {
			return {
				item_logo: true,
				itemt_contet: false
			}
		},
		methods: {
      ...mapMutations([
        'setPage','logout'
      ]),
			showshadow: function() {
				this.item_logo = false;
				this.itemt_contet = true;
			},
			hideshadow: function() {
				this.item_logo = true;
				this.itemt_contet = false;
			},
			toPage(path){
        this.$router.push(path)
			},
      toLogout(){
        this.$confirm('确认退出当前账号？', '退出登录', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.logout();
          this.$router.push({name:'home'});
        }).catch(() => {
        });
      }
		},
		mounted() {

		},
    computed: mapState([
      'loginPage','haslogin','userData'
    ]),
	}
</script>

<style lang="scss" scoped>
	@import '../../components/style/mixin';
	.navbox{height: 88px;background: url("../../images/top_bg.png") no-repeat top 0 left 0 /100% 100%;text-align: center;white-space: nowrap}
	.logo{padding-top: 20px}
	.navbox>div{display: inline-block;vertical-align: top}
	.kunlun_logo{width: 251px;height: 42px}
	.list{height: 83px;margin-left: 280px}
	.list a{font-size: 16px;width: 100px;display: inline-block;text-align: center;height: 100%;padding-top: 33px;box-sizing: border-box;margin-right: 15px}
	.list .router-link-active{color: #1990FF;border-bottom: 3px solid #1990FF;background-color: rgb(248,248,248)}
	.action{font-size: 14px;height: 68px;padding-top: 33px;margin-left: 220px;}
	.action a{margin-right: 20px;}
	.action .router-link-active{color: #1990FF}
	.action span{margin-right: 20px;cursor: pointer}
	.pageShow{color: #1990FF}
	.logout{color: #1990FF;cursor: pointer}
	@media screen and  (max-width: 1400px){
		.logo{margin-left: 10px}
		.action{margin-left: 110px}
		.list{margin-left: 50px}
		.list a{margin-right: 0;width: 90px}
	}
</style>
